<template>
  <div
    class="flex flex-col items-center justify-center w-[30rem]"
    style="border-radius: 53px"
  >
    <div
      class="w-full"
      style="
        border-radius: 56px;
        padding: 0.3rem;
        background: linear-gradient(
          180deg,
          var(--primary-color) 10%,
          rgba(33, 150, 243, 0) 30%
        );
      "
    >
      <div
        class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20"
        style="border-radius: 53px"
      >
        <div class="text-center mb-8">
          <span class="text-2xl font-bold text-primary">eGesparc</span>
        </div>

        <div class="flex flex-col items-center justify-center">
          <AuthBitrix24LoginButton
            :mode="bitrix24LoginMode"
            @success="$emit('bitrix24Loginsuccess')"
          />
        </div>

        <Divider layout="horizontal" class="!hidden md:!flex"
          ><b>OU</b></Divider
        >
        <AuthLoginForm @success="$emit('loginFormSuccess')" />
      </div>
    </div>
  </div>
</template>
<script setup>
import AuthBitrix24LoginButton from "@/components/auth/AuthBitrix24LoginButton.vue";
import Divider from "primevue/divider";
import AuthLoginForm from "@/components/auth/AuthLoginForm.vue";
import { defineProps, defineEmits } from "vue";

defineProps(["bitrix24LoginMode"]);
defineEmits(["loginFormSuccess", "bitrix24Loginsuccess"]);
</script>
